import CircleClock from "@svg/new-design/circle-clock";
import { FC } from "react";
import { productCardDurationCalculator } from "./helpers";
interface Props {
  duration:
    | {
        hours: number;
        minutes: number;
        rounded_in_hour: number;
        in_minutes: number;
      }
    | undefined;
  showTime: boolean;
  hugElement: boolean;
}
const CardDuration: FC<Props> = ({ duration, hugElement, showTime }) => {
  const durationLabel = productCardDurationCalculator(duration);
  const renderClock = Boolean(durationLabel);

  const durationIcon = renderClock ? (
    <CircleClock
      className="h-4 md:h-fds-18 w-4 md:w-fds-18 text-fds-secondary"
      fill="currentColor"
    />
  ) : null;
  return (
    <div className="flex gap-1.5  mt-1 md:mt-1.5  text-fds-secondary ">
      {durationIcon}
      <p className="text-fds-secondary body-xxsm md:body-xsm">
        {showTime ? (
          renderClock ? (
            durationLabel
          ) : !hugElement ? (
            <br />
          ) : null
        ) : null}
      </p>
    </div>
  );
};

export default CardDuration;
